module.exports = __webpack_public_path__ + "static/img/LK.04b20662.svg";